// 首页模块
import request from '@/utils/request'

// 加载专家主页所有数据
export const getDetail = (id) => {
  return request({
    method: 'get',
    url: '/post/detail',
    params: { id }
  })
}